import {getValidatedStagedUpdatesReactive} from "../pages/api/agentsApi";
import {untrustedModuleLoadsExist} from "../pages/api/relatedModuleLoadsApi";
import {checkIsUsingRememberMe} from "./storageHelper";
import ClearIcon from "@mui/icons-material/Clear";
import {IconButton} from "@mui/material";
import {MuiIconButtonWithTooltip, MuiIconWithTooltip} from "../components/muiComponents";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";
import {convertDllTrustError} from "../pages/private/relatedModuleLoads";

/*
    Need to take in uniqueProcessIdentifier since the var name is diff for creations and injections.
    Assumes col name is untrustedModuleLoad
 */
export function untrustedModuleLoadValueFormatter(params, uniqueProcessIdentifier){
    if(params.node.data.untrustedModuleLoad){
        return params.node.data.untrustedModuleLoad
    }

    if(params.node.data.zenGroupId && params.node.data.agentId && uniqueProcessIdentifier){
        untrustedModuleLoadsExist(params.node.data.zenGroupId, params.node.data.agentId, uniqueProcessIdentifier).then(response => {
            if(response["exists"] === true){
                //exists, show text and we will show icon
                if(response.trustErrorsList && response.trustErrorsList.length > 0){
                    //Need to show all possible values from trustErrorsList in cell
                    let convertedVals = []
                    response.trustErrorsList.forEach((trustError) => {
                        convertedVals.push(convertDllTrustError(trustError))
                    })
                    params.node.data.untrustedModuleLoad = convertedVals.join(", ")
                }
                else{
                    params.node.data.untrustedModuleLoad = "Untrusted Module Load Found"
                }
            }
            else{
                //does not exist
                params.node.data.untrustedModuleLoad = " " //need blank space so spinner will stop
            }
            params.api.refreshCells({columns: ["untrustedModuleLoad"], rowNodes: [params.node], suppressFlash: false, force: false})
        }).catch(function (error) {
            params.node.data.untrustedModuleLoad = " "
            params.api.refreshCells({columns: ["untrustedModuleLoad"], rowNodes: [params.node], suppressFlash: false, force: false})
        })
        params.node.data.untrustedModuleLoad = params.node.data.agentId //set to agentId, cell renderer will show spinner in this case
        return params.node.data.agentId
    }
}

export function untrustedModuleLoadCellRenderer(params, uniqueProcessIdentifier){
    let cellDiv = ""
    if(params.node.data.agentId === params.valueFormatted ){
        cellDiv = <FontAwesomeIcon
            className="contain fa-pulse mr-1"
            icon="fa-light fa-spinner"
            size="lg"
            name="untrustedModuleLoading"
        />
    }
    else if(params.valueFormatted && params.valueFormatted.trim().length > 0){
        cellDiv = <div className={"mb-1"}>
            <MuiIconButtonWithTooltip
                icon={
                    <FontAwesomeIcon
                        className="object-contain cursor-pointer"
                        icon="fa-duotone fa-shield-xmark"
                        size="xs"
                        onClick={() => {
                            let baseUrl = "/private/relatedDLLs";
                            let urlSearchParams = new URLSearchParams();
                            urlSearchParams.append("uniqueProcessIdentifier", JSON.stringify(uniqueProcessIdentifier));
                            urlSearchParams.append("agentId", JSON.stringify(params.node.data.agentId));
                            urlSearchParams.append("zenGroupId", JSON.stringify(params.node.data.zenGroupId));

                            let urlWithParams = `${baseUrl}?${urlSearchParams.toString()}`;
                            let rememberMeEnabled = checkIsUsingRememberMe()
                            if(rememberMeEnabled){
                                //for now, if using rem me then open in new tab
                                window.open(urlWithParams, "_blank", "noreferrer");
                            }
                            else{
                                //for now, if not using rem me then we have to open in same tab
                                window.open(urlWithParams, "_self", "noreferrer");
                            }

                        }}
                    />
                }
                tooltipTitle={"Related untrusted module load(s) found, click to view"}
                tooltipPlacement={"bottom-start"}
            />
        </div>
    }
    else{
        cellDiv = ""
    }

    return(
        <div id ="fortooltip" className={"flex flex-nowrap items-center justify-start gap-x-0"}>
            {cellDiv}
            {params.valueFormatted}
        </div>
    )
}